import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { createRoot } from 'react-dom/client';
import { AspectType, majorAspects, getObjectName, isNotTransits, checkAspect, ObjectType } from '@chronos/astro-lib';
import { hideMapInfoPopup, showMapInfoPopup, isCompatibility } from './utils';
import { aspectsIcons, objectNames } from './defs';
import { degToString, distance } from '@chronos/api';
import astro from './astro';
import { getArrangeObjects } from './Objects';
import { WITH_OUTER_OFFSET } from './Circle';
function isAccurateAspect(a) {
    const orbises = {
        10: 3,
        9: 3,
        7: 2,
        5: 2
    };
    return a.realOrbise <= (orbises[a.orbise] || a.orbise);
}
export var MinorAspectsModes;
(function (MinorAspectsModes) {
    MinorAspectsModes[MinorAspectsModes["On"] = 0] = "On";
    MinorAspectsModes[MinorAspectsModes["Off"] = 1] = "Off";
    MinorAspectsModes[MinorAspectsModes["School"] = 2] = "School";
})(MinorAspectsModes || (MinorAspectsModes = {}));
export default class Aspects extends React.Component {
    constructor() {
        super(...arguments);
        this._container = React.createRef();
        this.update = (newProps) => {
            var _a;
            if (!this._container.current) {
                return;
            }
            const { personalization } = newProps.mapSettings;
            const { computedRadius } = newProps;
            const iconSize = newProps.mode === 'horar' ? newProps.radius * personalization.circle.aspects.icon * 2 : newProps.radius * personalization.circle.aspects.icon;
            const radius = newProps.mode === 'horar'
                ? newProps.radius
                : newProps.radius *
                    (newProps.hasExt && !newProps.hasOuter
                        ? computedRadius.internalExt
                        : newProps.hasExt && newProps.hasOuter
                            ? computedRadius.internalExt - WITH_OUTER_OFFSET
                            : computedRadius.internal);
            let _aspects = newProps.aspects;
            let aObjects = [];
            const { showHorarAspects, astroSettings: { hideTransitAspects }, indicator: { prognosticsNatal } } = newProps.mapSettings;
            if (newProps.mode === 'horar') {
                aObjects = getArrangeObjects(newProps.objects.map((o, id) => ({ ...o, id }))
                    .filter((obj) => (obj.id !== ObjectType.Chiron || !isNotTransits(newProps.mode)) && obj.id !== ObjectType.Selena), newProps.houses, +(newProps.radius * personalization.circle.objects.iconSize / 4).toFixed(2), newProps.horarSigns, 3, []);
                _aspects = _aspects.filter(aspect => {
                    var _a, _b, _c;
                    return ((!((_a = astro.getOrbise('natal', aspect.obj1, aspect.type)) === null || _a === void 0 ? void 0 : _a.disabled) &&
                        !((_b = astro.getOrbise('natal', aspect.obj2, aspect.type)) === null || _b === void 0 ? void 0 : _b.disabled)) ||
                        ((_c = newProps.highlights) === null || _c === void 0 ? void 0 : _c.includes(aspect.id))) &&
                        majorAspects.includes(aspect.type) &&
                        aspect.obj2 <= ObjectType.Saturn &&
                        aspect.obj1 <= ObjectType.Saturn;
                });
            }
            else {
                _aspects = _aspects.filter(aspect => {
                    var _a, _b, _c;
                    const isVisible = (!((_a = astro.getOrbise(newProps.mode, aspect.obj1, aspect.type)) === null || _a === void 0 ? void 0 : _a.disabled)
                        && !((_b = astro.getOrbise(newProps.mode, aspect.obj2, aspect.type)) === null || _b === void 0 ? void 0 : _b.disabled)
                        || ((_c = newProps.highlights) === null || _c === void 0 ? void 0 : _c.includes(aspect.id))
                        || newProps.synastryTransits);
                    if (newProps.minorAspectsMode === MinorAspectsModes.School || majorAspects.includes(aspect.type)) {
                        return isVisible;
                    }
                    return newProps.minorAspectsMode === MinorAspectsModes.On;
                });
            }
            if (newProps.mode === 'transits' &&
                newProps.objects.length) {
                _aspects = _aspects.filter(aspect => {
                    var _a, _b;
                    return ((_a = newProps.highlights) === null || _a === void 0 ? void 0 : _a.includes(aspect.id)) ||
                        (hideTransitAspects ? (aspect.obj2 > ObjectType.Mars || ((_b = newProps.objects[aspect.obj2]) === null || _b === void 0 ? void 0 : _b.speed) <= 0) : true)
                            && aspect.obj2 !== ObjectType.Chiron
                            && aspect.obj2 !== ObjectType.NorthNode
                            && aspect.obj2 !== ObjectType.SouthNode
                            && aspect.obj1 !== ObjectType.Chiron;
                });
            }
            const indicatorPrognosticsNatal = prognosticsNatal === null || prognosticsNatal === void 0 ? void 0 : prognosticsNatal[newProps.mode];
            const nodes = [ObjectType.NorthNode, ObjectType.SouthNode];
            if (!indicatorPrognosticsNatal && ['solars', 'prog_natal', 'transits'].includes(newProps.mode)) {
                _aspects = _aspects.filter(aspect => {
                    var _a;
                    return ((_a = newProps.highlights) === null || _a === void 0 ? void 0 : _a.includes(aspect.id)) || !(newProps.mode === 'prog_natal' && (aspect.obj1 >= ObjectType.House1 || aspect.obj2 >= ObjectType.House1))
                        && !(aspect.type === AspectType.Opposition
                            && nodes.includes(aspect.obj1) && nodes.includes(aspect.obj2));
                });
            }
            const { transitMode } = ((_a = newProps.mapSettings.indicator.compatibilityTransits) === null || _a === void 0 ? void 0 : _a[newProps.mode]) || {};
            if (isCompatibility(newProps.mode) && transitMode === 2) {
                _aspects = _aspects.filter((aspect) => aspect.type === AspectType.Conjunction && ![aspect.obj1, aspect.obj2].includes(-1));
            }
            const container = this._container.current;
            const w3Url = 'http://www.w3.org/2000/svg';
            while (container.childElementCount < _aspects.length) {
                const group = document.createElementNS(w3Url, 'g');
                group.style.cursor = 'pointer';
                const line = document.createElementNS(w3Url, 'line');
                group.append(line);
                const lineBack = document.createElementNS(w3Url, 'line');
                group.append(lineBack);
                const back = document.createElementNS(w3Url, 'circle');
                back.setAttribute('r', (iconSize / 2).toString());
                back.setAttribute('fill', 'transparent');
                group.append(back);
                const icon = document.createElementNS(w3Url, 'svg');
                icon.setAttribute('viewBox', '0 0 24 24');
                icon.setAttribute('width', '24');
                icon.setAttribute('height', '24');
                group.append(icon);
                container.append(group);
            }
            _aspects.forEach((aspect, ind) => {
                const noIcon = aspect.type === AspectType.Conjunction ||
                    aspect.type === AspectType.Opposition;
                const lon1 = newProps.mode === 'horar' ? aObjects.find(obj => obj.id === aspect.obj1).lon : aspect.lon1;
                const lon2 = newProps.mode === 'horar' ? aObjects.find(obj => obj.id === aspect.obj2).lon : aspect.lon2;
                const p1 = newProps.point(radius, lon1);
                const p2 = newProps.point(radius, lon2);
                const pc = {
                    x: (p1.x + p2.x) / 2,
                    y: (p1.y + p2.y) / 2
                };
                const gap = noIcon ? 0 : iconSize;
                const len = (distance(p1, p2) - gap) / 2;
                const isHighlighted = !newProps.highlights || newProps.highlights.includes(aspect.id);
                const opacity = isHighlighted ? 1 : 0.2;
                const color = `rgba(var(--circle-aspects-${aspect.type}-rgb-${personalization.circle.colorThemes.aspects.active}), ${opacity})`;
                const strokeDasharray = majorAspects.includes(aspect.type) ? `${len} ${gap}` : '5, 5';
                const strokeMul = newProps.radius * (isHighlighted || newProps.strongs.aspects.find((a) => a.type === aspect.type &&
                    a.obj1 === aspect.obj1 &&
                    a.obj2 === aspect.obj2 &&
                    a.weight > 0)
                    ?
                        0.0015 :
                    isAccurateAspect(aspect) ? 0.001 : 0.0005) * personalization.circle.aspects.width;
                const group = container.childNodes[ind];
                group.onmouseenter = (evt) => {
                    if (newProps.mapSettings.access.limited)
                        return false;
                    const _t = newProps.mapSettings.t;
                    if (newProps.mode !== 'solars' && !isCompatibility(newProps.mode)) {
                        const diff = checkAspect(aspect.orbise, aspect.lon1, aspect.lon2, aspect.type, {
                            ...astro.checkAspectOpts(showHorarAspects && this.props.mode === 'horar' ? 'natal' : this.props.mode),
                            isRounded: false
                        });
                        showMapInfoPopup(evt.target, [
                            `${aspect.type}°  ${(_t === null || _t === void 0 ? void 0 : _t(getObjectName(aspect.obj1))) || objectNames[aspect.obj1].ru}  ${((aspect === null || aspect === void 0 ? void 0 : aspect.diff) || 0) < 0 ? '><' : '<>'}  ${(_t === null || _t === void 0 ? void 0 : _t(getObjectName(aspect.obj2))) || objectNames[aspect.obj2].ru}`,
                            `${degToString(diff.lon, { isInternational: false, showSeconds: true })} (${degToString(diff.diff, { isInternational: false, showSeconds: true })})`
                        ], evt);
                    }
                    newProps.onHover('aspect', aspect.id);
                };
                group.onmouseleave = () => {
                    newProps.onHover('aspect', -1);
                    hideMapInfoPopup();
                };
                group.onclick = () => newProps.onHelp('aspects', aspect.type);
                const line = group.childNodes[0];
                const lineBack = group.childNodes[1];
                line.setAttribute('x1', p1.x.toString());
                line.setAttribute('y1', p1.y.toString());
                line.setAttribute('x2', p2.x.toString());
                line.setAttribute('y2', p2.y.toString());
                lineBack.setAttribute('x1', p1.x.toString());
                lineBack.setAttribute('y1', p1.y.toString());
                lineBack.setAttribute('x2', p2.x.toString());
                lineBack.setAttribute('y2', p2.y.toString());
                if (aspect.type === 90 && aspect.obj1 === 5 && aspect.obj2 === 7) {
                    group.classList.add('square');
                }
                else {
                    group.classList.remove('square');
                }
                line.setAttribute('stroke', color);
                line.setAttribute('stroke-width', aspect.type === 0 ? (strokeMul * 5).toString() : strokeMul.toString());
                line.setAttribute('stroke-dasharray', strokeDasharray);
                line.setAttribute('fill', 'none');
                lineBack.setAttribute('stroke', 'transparent');
                lineBack.setAttribute('stroke-width', (strokeMul * 10).toString());
                lineBack.setAttribute('fill', 'none');
                line.style.display = 'block';
                lineBack.style.display = 'block';
                const back = group.childNodes[2];
                const icon = group.childNodes[3];
                icon.tabIndex = -1;
                if (noIcon) {
                    back.style.display = 'none';
                    icon.style.display = 'none';
                }
                else {
                    back.setAttribute('cx', pc.x.toString());
                    back.setAttribute('cy', pc.y.toString());
                    back.style.display = 'block';
                    const Icon = aspectsIcons[aspect.type];
                    icon.setAttribute('x', (pc.x - iconSize / 2).toString());
                    icon.setAttribute('y', (pc.y - iconSize / 2).toString());
                    icon.style.display = 'block';
                    createRoot(icon).render(_jsx(Icon, { fill: color, stroke: color, strokeWidth: strokeMul, width: iconSize, height: iconSize }));
                }
                group.style.display = 'block';
            });
            for (let i = _aspects.length; i < container.childElementCount; i++) {
                container.childNodes[i].style.display = 'none';
            }
        };
    }
    shouldComponentUpdate(newProps) {
        this.update(newProps);
        return Boolean(newProps.isEditor) || newProps.mapSettings.personalization.name !== this.props.mapSettings.personalization.name;
    }
    componentDidMount() {
        this.update(this.props);
    }
    render() {
        return _jsx("g", { ref: this._container });
    }
}
